import produce from 'immer'
import { Reducer } from 'redux'
import {
  SET_USER_DETAILS,
  SET_USER_IS_LOGGED,
  SET_USER_ROLES,
  SET_USER_IS_CLARILIS,
  SET_USER_IS_DOCDRAFTER,
  SET_USER_IS_DOCDRAFTER_CLARILIS,
  SET_ACCESS_ROLES,
  SET_USER_HAS_SMART_FEATURES,
  SET_PRIMARY_AOL,
  SET_PRIMARY_AOL_SET_BY_USER,
  SET_PRACTISING_AOL
} from 'redux/actions/types'

export interface UserState {
  details: {
    email: string
    isExternalAuth: boolean
  }
  isLogged: boolean
  roles: string[]
  isCore: boolean
  isClarilis: boolean
  isDocDrafter: boolean
  isDocDrafterClarilis: boolean
  isLimitedAccess: boolean
  accessRoles: string[]
  hasSmartFeatures?: boolean
  primaryAol: string
  primaryAolSetByUser?: boolean
  practisingAol: string
}

const initialState: UserState = {
  details: { email: '', isExternalAuth: false },
  isLogged: false,
  roles: [],
  isCore: false,
  isClarilis: false,
  isDocDrafter: false,
  isLimitedAccess: false,
  isDocDrafterClarilis: false,
  accessRoles: [],
  hasSmartFeatures: undefined,
  primaryAol: 'corporate',
  primaryAolSetByUser: undefined,
  practisingAol: ''
}

const user: Reducer<UserState, any> = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_DETAILS:
      return produce(state, draft => {
        draft.details = { ...action.details }
      })
    case SET_USER_IS_LOGGED:
      return produce(state, draft => {
        draft.isLogged = action.isLogged
      })
    case SET_USER_ROLES:
      return produce(state, draft => {
        draft.roles = [...action.roles]
      })
    case SET_ACCESS_ROLES:
      return produce(state, draft => {
        draft.accessRoles = [...action.accessRoles]
      })
    case SET_USER_IS_CLARILIS:
      return produce(state, draft => {
        draft.isClarilis = action.isClarilis
      })
    case SET_USER_IS_DOCDRAFTER:
      return produce(state, draft => {
        draft.isDocDrafter = action.isDocDrafter
      })
    case SET_USER_IS_DOCDRAFTER_CLARILIS:
      return produce(state, draft => {
        draft.isDocDrafterClarilis = action.isDocDrafterClarilis
      })
    case SET_USER_HAS_SMART_FEATURES:
      return produce(state, draft => {
        draft.hasSmartFeatures = action.hasSmartFeatures
      })
    case SET_PRIMARY_AOL:
      return produce(state, draft => {
        draft.primaryAol = action.primaryAol
      })
    case SET_PRIMARY_AOL_SET_BY_USER:
      return produce(state, draft => {
        draft.primaryAolSetByUser = action.primaryAolSetByUser
      })
    case SET_PRACTISING_AOL:
      return produce(state, draft => {
        draft.practisingAol = action.practisingAol
      })
    default:
      return state
  }
}

export default user
